import cx from 'classnames';
import type { ReactNode } from 'react';
import { forwardRef } from 'react';
import styles from './styles.module.css';

export interface ModalBodyProps {
  children: NonNullable<ReactNode>;
  className?: string;
}

export const ModalBody = forwardRef<HTMLDivElement, ModalBodyProps>(({ children, className }, ref) => {
  return (
    <div ref={ref} className={cx(styles.Body, className)}>
      {children}
    </div>
  );
});
